// Recent geopende dossiers voor het opdrachtpalet; per apparaat bewaard, alleen id, referentie en titel.
export interface RecentItem {
  id: string;
  reference: string;
  title: string;
}
const KEY = "bres:recent";

export function readRecent(): RecentItem[] {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) ?? "[]") as RecentItem[];
    return Array.isArray(list) ? list.slice(0, 6) : [];
  } catch {
    return [];
  }
}

export function pushRecent(item: RecentItem): void {
  try {
    const next = [item, ...readRecent().filter((x) => x.id !== item.id)].slice(0, 6);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // geen opslag
  }
}
